import React from 'react'
import { Button, ButtonProps } from 'react-bootstrap'

interface PropType extends ButtonProps {
	buttonText: string
	isSubmitting: boolean
	icon: React.ReactNode
}

const style = {
	color: 'white',
	border: 'none',
	borderRadius: '10px',
	width: '100%'
}

const EButton: React.FC<PropType> = (props: PropType) => {
	return <Button variant="primary" style={style} className={props.className}>{props.icon} &nbsp; {props.buttonText} </Button>
}

export default EButton